import i18n from "../i18n";

// ค่าเริ่มต้นของ locales ขึ้นกับภาษาที่เลือก: ภาษาไทยแสดงปี พ.ศ. ตามเดิม ภาษาอังกฤษแสดงปี ค.ศ. และชื่อเดือนภาษาอังกฤษ
export const dateTimeToView = (
  date?: any,
  isFullYear = true,
  locales = i18n.language === "en" ? "en-GB" : "th"
) => {
  let today: any = Date.now();
  if (date) today = new Date(date);
  return (
    new Intl.DateTimeFormat(locales, {
      year: isFullYear ? "numeric" : "2-digit",
      month: "2-digit",
      day: "2-digit",
      hour: "numeric",
      minute: "numeric",
      hour12: false,
    }).format(today) + (locales === "th" ? " น." : "") // i18n-ignore (Thai time suffix, Thai locale only)
  );
};

export const dateToView = (date?: any, isFullYear = true, locales = i18n.language === "en" ? "en-GB" : "th") => {
  let today: any = Date.now();
  if (date) today = new Date(date);
  return new Intl.DateTimeFormat(locales, {
    year: isFullYear ? "numeric" : "2-digit",
    month: "2-digit",
    day: "2-digit",
  }).format(today);
};

export const timeToView = (date?: any, isFullYear = true, locales = i18n.language === "en" ? "en-GB" : "th") => {
  let today: any = Date.now();
  if (date) today = new Date(date);
  return new Intl.DateTimeFormat(locales, {
    hour: "numeric",
    minute: "numeric",
    hour12: false,
  }).format(today);
};

enum SHORT_DAY_OF_WEEK {
  Sun = `Sun`,
  Mon = `Mon`,
  Tue = `Tue`,
  Wed = `Wed`,
  Thu = `Thu`,
  Fri = `Fri`,
  Sat = `Sat`,
}
export const dateOfWeek = (type: any = "SHORT") => {
  const dateOfWeek = SHORT_DAY_OF_WEEK;
  return type === "SHORT" ? SHORT_DAY_OF_WEEK : [];
};

export const fullDateToView = (
  date?: any,
  isFullYear = true,
  locales = i18n.language === "en" ? "en-GB" : "th"
) => {
  let today: any = Date.now();
  if (date) today = new Date(date);
  return new Intl.DateTimeFormat(locales, {
    year: "numeric",
    month: "long",
  }).format(today);
};

export const fullDate = (date?: any, isFullYear = true, locales = i18n.language === "en" ? "en-GB" : "th") => {
  let today: any = Date.now();
  if (date) today = new Date(date);
  return new Intl.DateTimeFormat(locales, {
    day: "numeric",
    year: "numeric",
    month: "long",
  }).format(today);
};

export const shortnessDate = (
  date?: any,
  isFullYear = true,
  locales = i18n.language === "en" ? "en-GB" : "th"
) => {
  let today: any = Date.now();
  if (date) today = new Date(date);
  return new Intl.DateTimeFormat(locales, {
    day: "numeric",
    month: "short",
  }).format(today);
};
export const shortnessDatemonth = (
  date?: any,
  isFullYear = true,
  locales = i18n.language === "en" ? "en-GB" : "th"
) => {
  let today: any = Date.now();
  if (date) today = new Date(date);
  return new Intl.DateTimeFormat(locales, {
    month: "long",
  }).format(today);
};
export const lnessDatemonth = (
  date?: any,
  isFullYear = true,
  locales = i18n.language === "en" ? "en-GB" : "th"
) => {
  let today: any = Date.now();
  if (date) today = new Date(date);
  return new Intl.DateTimeFormat(locales, {
    month: "short",
  }).format(today);
};

export const monthOnly = (monthNumber: any) => {
  const months = [
    i18n.t("มกราคม"),
    i18n.t("กุมภาพันธ์"),
    i18n.t("มีนาคม"),
    i18n.t("เมษายน"),
    i18n.t("พฤษภาคม"),
    i18n.t("มิถุนายน"),
    i18n.t("กรกฎาคม"),
    i18n.t("สิงหาคม"),
    i18n.t("กันยายน"),
    i18n.t("ตุลาคม"),
    i18n.t("พฤศจิกายน"),
    i18n.t("ธันวาคม"),
  ];

  if (monthNumber >= 1 && monthNumber <= 12) {
    return months[monthNumber - 1];
  } else {
    return "Invalid Month";
  }
};

export const generateYearRange = (
  startYear: number,
  range: number
): number[] => {
  const currentYear = new Date().getFullYear(); // Gregorian year
  const thaiCurrentYear = currentYear + 543; // Convert to Buddhist Era year
  const endYear = thaiCurrentYear + range;
  const years: number[] = [];

  for (let year = startYear; year <= endYear; year++) {
    years.push(year);
  }

  return years;
};

export const generateYearRangeAgo = (
  startYear: number,
  range: number
): number[] => {
  const years: number[] = [];

  for (let year = startYear; year > startYear - range; year--) {
    years.push(year);
  }

  return years;
};

export const formatDateToThai = (date: Date | null) => {
  if (!date) return { day: null, month: null, year: null };

  const currentDate = new Date(date);
  const day = currentDate.getDate();
  const month = currentDate.getMonth();
  const year = currentDate.getFullYear() + 543;

  return { day, month, year };
};

export const calculateAge = (dob: string | Date): number | null => {
  if (!dob) return null;

  const dobDate = new Date(dob);
  const today = new Date();

  let age = today.getFullYear() - dobDate.getFullYear();
  const monthDifference = today.getMonth() - dobDate.getMonth();

  // If today's month is before the birth month, or it's the birth month but today is before the birth day, subtract one year
  if (
    monthDifference < 0 ||
    (monthDifference === 0 && today.getDate() < dobDate.getDate())
  ) {
    age--;
  }

  return age;
};
